export const ExtraFeeTypes = "ExtraFeeTypes";
